import { DefaultError } from '@tanstack/query-core';
import { UseSuspenseQueryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { fetchAuctionCategories } from 'api/campaigns';
import { campaignQueryKeys } from 'queries/campaign-query-keys';
import { AuctionCategory } from 'types/domain';
import { PaginatedData } from 'types/pagination';

const useAuctionCategories = (
    props: { campaignId: number; auctionId: number },
    options: Omit<
        UseSuspenseQueryOptions<
            PaginatedData<AuctionCategory>,
            DefaultError,
            AuctionCategory[],
            any
        >,
        'queryKey'
    > = {},
) => {
    const { campaignId, auctionId } = props;
    return useSuspenseQuery({
        queryKey: campaignQueryKeys.auctionCategories(campaignId, auctionId),
        queryFn: () => fetchAuctionCategories(campaignId, auctionId),
        select: data => {
            let listNumber = 0;
            return data.data.map(item => {
                return { ...item, listNumber: item.is_published ? ++listNumber : undefined };
            });
        },
        ...options,
    });
};

export { useAuctionCategories };
